import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageLIGAF2 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Key Wins for Sevilla and Sociedad",
            author: "footballgirl",
              date: "March 5, 2026",
            image: "images/ligaf/2a.jpg",
         content: `<p>On March 4 2026 , Sevilla W
          secured a 2-1 victory over Atletico Madrid W,
           while Real Sociedad W defeated Espanyol W 
           by the same scoreline in Liga F action.
            Athletic Club W edged Eibar W 1-0, 
            and Real Madrid W beat
             UDG Tenerife W 2-0, 
             affecting the mid-table battles and 
             top positions. Upcoming matches 
             include Atletico Madrid W vs Logrono W,
          promising more competitive fixtures.</p>`,
            tags: ["wins", "Sevilla", "Real Sociedad", "Athletic Club", "Real Madrid", "Atletico Madrid", "Liga F"],
          navIndices: { prev: 'ligaf-1', next: 'ligaf-3' }
        });
    }

    init() {
        console.log('ArticlePageLIGAF2 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to Liga F
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'ligaf' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_ligaf.png';
            leagueLogo.alt = 'Liga F';
        }
    }
}